export const ICON_LABEL = {
    web: 'monitor',
    extension: 'puzzle-piece'
};
